<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="用户服务协议：" prop="privacyPolicy">
        <editor :value="ruleForm.privacyPolicy" :height="350" v-model="ruleForm.privacyPolicy"></editor>
      </el-form-item>
      <el-form-item label="隐私政策：" prop="serviceAgreement">
        <editor :value="ruleForm.serviceAgreement" :height="350" v-model="ruleForm.serviceAgreement"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { privacyWatch, updatePrivacy } from '@/api/setting'
import Editor from '@/components/Editor.vue'

export default {
  name: 'Privacy',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        privacyPolicy:'',
        serviceAgreement:''
      },
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['clean'],
              ['image']
            ]
          }
        },
        placeholder: '请输入内容...'
      }
    }
  },
  mounted () {
    var that = this;
    privacyWatch({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm = data;
        }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      that.fullscreenLoading = true
      updatePrivacy(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/Privacy.vue